module.exports = __webpack_public_path__ + "img/logo_tbasigurari.8e5e4ff9.png";